import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_my-vitreo-preview/artifacts/mslzw0uv_MY%20VITREO.png";

const quickLinks = [
  { name: "Accueil", path: "/" },
  { name: "Services", path: "/services" },
  { name: "À propos", path: "/a-propos" },
  { name: "Prendre rendez-vous", path: "/rendez-vous" },
  { name: "Demander un devis", path: "/devis" },
  { name: "Contact", path: "/contact" },
];

const services = [
  "Remplacement de pare-brise",
  "Réparation de vitrage (impact)",
  "Pose de films teintés",
  "Calibrage ADAS",
];

const zones = [
  "Metz", "Thionville", "Nancy", "Forbach", 
  "Sarreguemines", "Amnéville", "Épinal"
];

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <img 
              src={LOGO_URL} 
              alt="MY VITREO" 
              className="h-16 w-auto object-contain brightness-0 invert"
            />
            <p className="text-slate-400 text-sm leading-relaxed">
              MY VITREO – La solution vitrage de confiance. Service professionnel de remplacement 
              et réparation de pare-brise à domicile.
            </p>
            <div className="space-y-3 pt-4">
              <a 
                href="tel:0695442788" 
                className="flex items-center gap-3 text-slate-300 hover:text-sky-400 transition-colors"
                data-testid="footer-phone"
              >
                <Phone className="w-5 h-5 text-sky-500" />
                <span>06 95 44 27 88</span>
              </a>
              <a 
                href="mailto:myvitreo@outlook.fr" 
                className="flex items-center gap-3 text-slate-300 hover:text-sky-400 transition-colors"
                data-testid="footer-email"
              >
                <Mail className="w-5 h-5 text-sky-500" />
                <span>myvitreo@outlook.fr</span>
              </a>
              <div className="flex items-start gap-3 text-slate-300">
                <MapPin className="w-5 h-5 text-sky-500 flex-shrink-0 mt-0.5" />
                <span>Basé à Metz – Intervention en Lorraine et Grand Est</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Liens rapides</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="text-slate-400 hover:text-sky-400 transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Nos services</h3>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service} className="text-slate-400 text-sm">
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* Zones */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Zones d'intervention</h3>
            <div className="flex flex-wrap gap-2">
              {zones.map((zone) => (
                <span 
                  key={zone}
                  className="px-3 py-1 bg-slate-800 text-slate-300 rounded-full text-sm"
                >
                  {zone}
                </span>
              ))}
            </div>
            <p className="text-slate-500 text-xs mt-4">
              Et toutes les communes de la région Lorraine et Grand Est
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} MY VITREO. Tous droits réservés.
          </p>
          <div className="flex gap-6">
            <Link to="/mentions-legales" className="text-slate-500 hover:text-slate-300 text-sm">
              Mentions légales
            </Link>
            <Link to="/politique-confidentialite" className="text-slate-500 hover:text-slate-300 text-sm">
              Politique de confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
